class GldSpanClick extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      //console.log('SPAN clicked init', this.dataset.child);
      this.decorateSubHeadings(this);
      this.onClick(this);
    });
  }

  onClick(element) {
    let rootElement = element.parentElement.parentElement.parentElement;
    // console.log('SPAN clicked click', rootElement);
    let id = element.dataset.child;
    rootElement.querySelectorAll('slider-component').forEach((ul) => ul.classList.add('hidden'));
    let querySelector = 'slider-component.wrap-' + id;
    // console.log('Query selector used: ' + querySelector);
    rootElement.querySelectorAll(querySelector)[0].classList.remove('hidden');
  }

  decorateSubHeadings(clickedElement) {
    clickedElement.parentElement.querySelectorAll('span-click').forEach((span) => span.classList.remove('selected'));
    clickedElement.classList.add('selected');
  }

}

customElements.define('span-click', GldSpanClick);
